import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { reduxForm } from 'redux-form'

import shortid from 'shortid';
import {CopyToClipboard} from 'react-copy-to-clipboard';

import './ToolTray.css';

import Checkbox from '../Checkbox/Checkbox.js'
import CustomField from '../CustomField/CustomField.js'
import Button from '../Button/Button.js'
import PatternThumbnail from '../PatternThumbnail/PatternThumbnail.js'
import Tabs from '../Tabs/Tabs.js'

import generateName from '../../pattern_utilities/generateName.js'
import { tryToGetTeamPatterns, tryToGetMyPatterns, setTrayOpen, tryToGetOfficialPatterns } from '../../actions/actions.export.js';

import canI from '../../canI.js';

const default_filters = [
  { value: "AUTOCAD", checked: false },
  { value: "REVIT", checked: false },
  { value: "INCH", checked: false },
  { value: "MM", checked: false },
  { value: "DRAFTING", checked: false },
  { value: "MODEL", checked: false },
  { value: "BAKED", checked: false },
  { value: "DRAWING", checked: false },
  { value: "TEMPLATE", checked: false },
  // { value: null, divider: true }
];

const paginate_size = 40;

class ToolLibraryTray extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  constructor(props){
    super(props);

    this.state = {
      searchPatterns: '',
      andOrPatterns: 'AND',
      filters: JSON.parse(JSON.stringify(default_filters)),
      lastScope: undefined,
      sortMethod: 'alphabetical',
      amount_to_show: 80 //paginate_size
    }

    this.toggleFilter = this.toggleFilter.bind(this);
    this.escFunction = this.escFunction.bind(this);
  }

  escFunction(event){
    const { dispatch, globalReducer } = this.props;
    if(event.keyCode === 27 && globalReducer.trayOpen.library){
      dispatch(setTrayOpen({tray: "library", open: false} ))
      this.setState({amount_to_show: paginate_size});
    }
  }
  componentDidMount(){
    document.addEventListener("keydown", this.escFunction, false);
  }
  componentWillUnmount(){
    document.removeEventListener("keydown", this.escFunction, false);
  }

  toggleFilter(index, filters){
    // var filters = this.state.filters;
    filters[index].checked = !filters[index].checked;

    if(filters[index].checked){
      var elem = document.getElementById('library-tray');
      elem.scrollTop = 0;
    }

    this.setState({
      filters: filters,
      amount_to_show: paginate_size
    })
  }

  componentWillReceiveProps(newprops){
    const { globalReducer } = this.props;
    const { team, user } = newprops;

    // console.log(newprops.globalReducer.trayOpen.library, globalReducer.trayOpen.library);
    if(!newprops.globalReducer.trayOpen.library && this.state.amount_to_show > paginate_size){
      this.setState({amount_to_show: 80});
    }
  }

  render(){
    const { user, dispatch, globalReducer, patternManager, cacheID, team} = this.props;
    const that = this;

    var patterns = patternManager.officialLibrary;

    var patternTags = {};
    for(var i in patterns){
      var p = patternManager.pristineCache[patterns[i]];
      patternTags[patterns[i]] = [];
      patternTags[patterns[i]].push(p.format);
      patternTags[patterns[i]].push(p.units);
      patternTags[patterns[i]].push(p.type);
      patternTags[patterns[i]].push(p.private ? 'PRIVATE' : 'PUBLIC');
      if(p.mode === 'template'){
        patternTags[patterns[i]].push('TEMPLATE');
      }
      if(p.mode === 'raster'){
        patternTags[patterns[i]].push('BAKED');
      }
      if(p.mode === 'drawing'){
        patternTags[patterns[i]].push('DRAWING');
      }
      for(var j in p.tags){
        patternTags[patterns[i]].push(p.tags[j]); 
      }
    }


    var filters = this.state.filters; //JSON.parse(JSON.stringify(default_filters));
    
    var tag_filters = [];
    for(var i in patterns){
      var p = patternManager.pristineCache[patterns[i]];
      for(var t in p.tags){
        var found = false;
        for(var f in tag_filters){
          if(tag_filters[f].value == p.tags[t]){
            found = true;
            break;
          }
        }

        if(!found) tag_filters.push({value: p.tags[t], checked: false, tag: true});
      }
    }

    tag_filters.sort((a,b)=>{
      if(a.value > b.value) return 1;
      if(a.value < b.value) return -1;
      return 0;
    })

    // for(var i in tag_filters){
    //   var found = false;
    //   for(var j in filters){
    //     if(filters[j].tag && filters[j].value === tag_filters[i].value){
    //       found = true;
    //       break;
    //     }
    //   }
    //   if(!found) filters.push(tag_filters[i]);
    // }


    for(var i = 0; i < filters.length; i++){
      filters[i].count = 0;
      for(var j in patternTags){
        if(patternTags[j].indexOf(filters[i].value) > -1){
          filters[i].count++;
        }
      }
      // if(i > 10){
      //   if(filters[i].count < 2){
      //     filters.splice(i, 1);
      //     i--;
      //   }
      // }
    }



    var filtersChecked = [];
    for(var i in filters){
      if(filters[i].checked){
        filtersChecked.push(filters[i].value);
      }
    }

    var filteredPatterns = [];
    for(var i = 0; i < patterns.length; i++){
      var p = patterns[i];
      if(filtersChecked.length > 0){
        if(this.state.andOrPatterns === 'AND'){
          var match = true;
          for(var j in filtersChecked){
            if(patternTags[p].indexOf(filtersChecked[j]) === -1){
              match = false; 
              break;
            }
          }
          if(!match) continue;
        } else {
          var match = false;
          for(var j in filtersChecked){
            if(patternTags[p].indexOf(filtersChecked[j]) > -1){
              match = true; 
              break;
            }
          }
          if(!match) continue;
        }
      }

      if(this.state.searchPatterns !== ''){
        if((generateName(patternManager.pristineCache[p]) + ' ' + (patternManager.pristineCache[p].tags || []).join(' ') + ' ' + (patternManager.pristineCache[p].projects || []).join(' ')).toLowerCase().indexOf(that.state.searchPatterns.toLowerCase()) > -1){
          // return thumbnail;
          filteredPatterns.push(p);
          continue;
        }
        continue;
      } else {
        // return thumbnail;
        filteredPatterns.push(p);
        continue;        
      }

      filteredPatterns.push(p);
    }

    if(filtersChecked.length > 0){
      for(var i = 0; i < filters.length; i++){
        filters[i].count = 0;
        for(var j in filteredPatterns){
          if(patternTags[filteredPatterns[j]].indexOf(filters[i].value) > -1){
            filters[i].count++;
          }
        }
      }
    }


    if(this.state.sortMethod === 'time'){
      filteredPatterns.sort(function(a,b){
        if(patternManager.pristineCache[a].updated_on > patternManager.pristineCache[b].updated_on) return -1;
        if(patternManager.pristineCache[a].updated_on < patternManager.pristineCache[b].updated_on) return 1;
        return 0;
      });
    } else if(this.state.sortMethod === 'alphabetical'){
      filteredPatterns.sort(function(a,b){
        if(patternManager.pristineCache[a].name.toLowerCase() > patternManager.pristineCache[b].name.toLowerCase()) return 1;
        if(patternManager.pristineCache[a].name.toLowerCase() < patternManager.pristineCache[b].name.toLowerCase()) return -1;
        return 0;
      });
    } else if(this.state.sortMethod === 'downloads'){
      filteredPatterns.sort(function(a,b){
        let ad = patternManager.pristineCache[a].stats ? patternManager.pristineCache[a].stats.downloads || 0 : 0;
        let bd = patternManager.pristineCache[b].stats ? patternManager.pristineCache[b].stats.downloads || 0 : 0;
        if(ad > bd) return -1;
        if(ad < bd) return 1;
        return 0;
      });
    }

    if(!user.isLoggedIn){
      filteredPatterns.sort((a,b)=>{
        let pa = patternManager.pristineCache[a];
        let pb = patternManager.pristineCache[b];

        if(pa.projects.indexOf('Preheat') > -1 && pb.projects.indexOf('Preheat') === -1) return -1;
        if(pa.projects.indexOf('Preheat') === -1 && pb.projects.indexOf('Preheat') > -1) return 1;
        return 0;
      })
    }


    let canAccessTemplates = canI(user, team, 'calculator_access', team.current);
    let canAccessLibrary = canI(user, team, 'library_access', team.current);
    let canAccessProLibrary = canI(user, team, 'pro_library_access', team.current);

    if(!canAccessProLibrary){
      filteredPatterns.sort(function(a,b){
        let an = patternManager.pristineCache[a].projects.indexOf('Pro Only');
        let bn = patternManager.pristineCache[b].projects.indexOf('Pro Only');
        if(an < bn) return -1;
        if(an > bn) return 1;
        return 0;
      });
    }
    
    if(!canAccessTemplates){
      filteredPatterns.sort(function(a,b){
        let an = patternManager.pristineCache[a].projects.indexOf('Pattycake Templates');
        let bn = patternManager.pristineCache[b].projects.indexOf('Pattycake Templates');
        if(an < bn) return -1;
        if(an > bn) return 1;
        return 0;
      });
    }

    var trimmed_patterns = filteredPatterns.slice(0, this.state.amount_to_show);

    return <div id="library-tray" className={"tool-pattern-tray " + (globalReducer.trayOpen.library ? "tool-pattern-tray-open" : "")}>
      <span 
        className="clickable exit-button" 
        onClick={(e)=>{ 
          dispatch(setTrayOpen({tray: "library", open: false} ));
          this.setState({amount_to_show: paginate_size});
        }}>
        <i className="fal fa-times fa-3x"/>
      </span>
      <div className="container-fluid">

        <div className="row row-push-down">
          <div className="col-md-12">
           
          </div>
        </div>

        <div className="row">
          <div className="col-md-2">
            <Tabs
              items={[
                  {
                    display: 'AND',
                    value: 'AND'
                  },
                  {
                    display: 'OR',
                    value: 'OR'
                  }
                ]}
              value={this.state.andOrPatterns}
              size='small'
              onChange={(e) => { this.setState({ andOrPatterns: e.value }) }}
              /> 
            <hr/>
            <h5>Filters</h5> 
            {
              filters.map((f, i)=>{

                return <div key={i + '_' + f.value} className="text-ellipsis">
                  {
                    f.divider ? <div>
                      <hr/> 
                      <h5>Tags</h5>
                    </div>
                    :
                    <nobr>
                      <Checkbox value={f.checked} onToggle={(e)=>{ this.toggleFilter(i, filters)}}/> 
                      <strong className="filter-text">
                        {f.value} <small className={"text-800 " + (f.count > 0 ? "text-secondary" : "translucent")}>{f.count}</small>
                      </strong>
                    </nobr>
                  }
                </div>
              })
            }
            
          </div>
          <div className="col-md-10">
            <div className="row row-padded"> 
              <div className="col-md-12">
                <CustomField
                  name="searchPatterns"
                  type='text'
                  placeholder='search the library...'
                  inline={true}
                  timeout={500}
                  autoCompleteList={patternManager.officialTags}
                  onChange={(e)=> { 
                    that.setState({
                      searchPatterns: e,
                      amount_to_show: paginate_size
                    }) 
                  }}
                  form={false}
                  />
              </div>
            </div>
            <div className="row">
              <div className="col-md-12"> 
                <div className="list-left">
                  <div className="list-item">
                    <Tabs
                      items={[
                          {
                            display: <i className="fas fa-font-case"/>,
                            value: 'alphabetical'
                          },
                          {
                            display: <i className="fas fa-clock"/>,
                            value: 'time'
                          },
                          {
                            display: <i className="fas fa-download"/>,
                            value: 'downloads'
                          }
                        ]}
                      value={this.state.sortMethod}
                      size='small'
                      onChange={(e) => { this.setState({ sortMethod: e.value }) }}
                      /> 
                  </div>
                  {/*<div className="list-item">
                    showing {trimmed_patterns.length} of {filteredPatterns.length} pattern{filteredPatterns.length !== 1 && "s"} found
                  </div>*/}
                  {
                    patterns.length == filteredPatterns.length ?
                    <div className="list-item">
                      Showing all {patterns.length} pattern{patterns.length !== 1 && "s"} 
                    </div> 
                    :
                    <div className="list-item">
                      Filtered to {filteredPatterns.length} of {patterns.length} pattern{patterns.length !== 1 && "s"} 
                    </div>
                  }


                  <div className="list-item">
                    {
                      filters.map((f, i)=>{
                        if(!f.checked) return
                        return <span className="filter-pill" onClick={(e)=>{ this.toggleFilter(i, filters); }} key={i}>
                          {f.value} <i className="fal fa-times"/>
                        </span>
                      })
                    }
                  </div>

                  {
                    patternManager.tryingToGetOfficialCalculators && 
                    <span className="text-muted list-item">
                      <i className="far fa-spinner-third fa-spin fa-fw fa-lg"/> Loading...
                    </span>
                  }

                </div>
                <hr/>
              </div>
            </div>
            <div className="row row-push-down-extra">
            { trimmed_patterns.map(function(p, i){

                let proOnly = patternManager.pristineCache[p].projects.indexOf('Pro Only') > -1;
                let preHeat = patternManager.pristineCache[p].projects.indexOf('Preheat') > -1;
                let template = patternManager.pristineCache[p].projects.indexOf('Pattycake Templates') > -1;

                let locked = false;
                let lockedMessage = "";

                if(!preHeat){
                  if(proOnly){
                    if(canAccessProLibrary){
                      locked = false;
                    } else {
                      locked = true;
                      lockedMessage = "Upgrade to Pro or create a team to access this pattern.";
                    }
                  } else if(template){
                    if(canAccessTemplates){
                      locked = false;
                    } else {
                      locked = true;
                      lockedMessage = "Upgrade to Pro or create a team to use this template."
                    }
                  } else {
                    if(canAccessLibrary){
                      locked = false;
                    } else {
                      locked = true;
                      lockedMessage = "Log in or create an account to get access to this pattern.";
                      if(user.isLoggedIn && !user.email_verified){
                        lockedMessage = "Verify your email address to get access to this pattern.";
                      }
                    }
                  }
                }

                return <div key={i} className="col-lg-3 col-md-4 col-sm-6">
                  <PatternThumbnail 
                    cacheID={p} 
                    locked={locked}
                    lockedMessage={lockedMessage}
                    light={true} 
                    official={true}
                    onClick={(e)=> { 
                      if((patternManager.pristineCache[patternManager.current_pattern].unsavedChanges || patternManager.tryingToUpdatePattern || patternManager.tryingToCreateNewPattern)){
                        // unsaved changes modal will catch here
                      } else {
                        dispatch(setTrayOpen({tray: "library", open: false}));
                      }
                    }}
                    />
                </div>
              })
            }
            {
              (filteredPatterns.length === 0 && patternManager.officialLibrary.length > 0) && <div className="col-md-12">
                <p className="text-lg">
                  There aren't any patterns that match the current search and filters.<br/>
                  Have something you're looking for? <Link to="/contact">Get in touch</Link> and we'll help make it happen.
                </p>
              </div>
            }
            {
              (filteredPatterns.length > trimmed_patterns.length) && <div className="col-md-12">
                <div className="list-center">
                  <Button
                    display="Show More"
                    color="grey"
                    size="medium"
                    onClick={(e)=>{this.setState({
                      amount_to_show: this.state.amount_to_show + paginate_size
                    })}}
                  />
                </div>
              </div>
            }
            </div>
          </div>
        </div>
      </div>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { 
    globalReducer, patternManager, user, team
    //...
  } = state;

  return {
    globalReducer, patternManager, user, team
    //...
  }
}

export default connect(mapStateToProps)(ToolLibraryTray);



// WEBPACK FOOTER //
// ./src/components/ToolTrays/ToolLibraryTray.js